export *  from './msw-partner-resources.route';
export *  from './msw-partner-resources.store';

export { default as MswPartnerResourcesModule } from './msw-partner-resources.store';
export { default as MswPartnerResourceRoute } from './msw-partner-resources.route';
